import { useSelector, useDispatch } from 'react-redux';
import React, { useState, useEffect } from 'react'
import { add } from '../slicers/addedJobSlicer'
import { change } from '../slicers/selectedStepSlicer'
import './steps.css'

function StepTwo() {
  const selectedMachine = useSelector((state) => state.stepOne.arr)
  const [step_input, setstep_input] = useState('');
  const dispatch = useDispatch()

  useEffect(() => {
    if (selectedMachine?.machineOperationType?.length > 0 && !step_input) {
      setstep_input(selectedMachine.machineOperationType[0].id);
    }
  }, [selectedMachine]);

  const useAddJobItem = () => {
    if (step_input) {
      dispatch(add([1, step_input]))
      dispatch(change(3))
    }
  }

  return (
    <div className="step-container">
      {/* Верхняя панель */}
      <div className="step-header">
        <button className="back-button" onClick={() => dispatch(change(1))}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#265c9d" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          <span>Назад</span>
        </button>
        <div className="step-indicator">
          <span className="step-dot completed"></span>
          <span className="step-dot active"></span>
          <span className="step-dot"></span>
          <span className="step-dot"></span>
        </div>
      </div>
      
      {/* Заголовок */}
      <div className="step-title-section">
        <h1 className="step-title">Выбор операции</h1>
        <p className="step-subtitle">
          Выберите тип выполненной работы
        </p>
      </div>
      
      {/* Список операций */}
      <div className="operations-list">
        {selectedMachine?.machineOperationType?.length > 0 ? (
          selectedMachine.machineOperationType.map((item) => (
            <div
              className={`operation-card ${step_input === item.id ? 'selected' : ''}`}
              key={item.id}
              onClick={() => setstep_input(item.id)}
            >
              <div className="operation-icon">
                {item.name.charAt(0)}
              </div>
              <div className="operation-info">
                <h3 className="operation-name">{item.name}</h3>
                <p className="operation-unit">
                  {item.unitOfWorkName} · {item.unitOfmeasurement?.nameCount || 'шт'}
                </p>
              </div>
              <div className="operation-radio"></div>
            </div>
          ))
        ) : (
          <div className="empty-state">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none">
              <rect x="3" y="3" width="18" height="18" rx="2" stroke="#CBD5E1" strokeWidth="1.5"/>
              <path d="M8 12H16" stroke="#CBD5E1" strokeWidth="1.5" strokeLinecap="round"/>
            </svg>
            <p>Нет доступных операций</p>
            <span>Для этого станка не назначены операции</span>
          </div>
        )}
      </div>
      
      {/* Кнопка Далее */}
      <button 
        className={`continue-button ${step_input ? 'active' : ''}`}
        onClick={useAddJobItem}
        disabled={!step_input}
      >
        <span>Продолжить</span>
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
          <path d="M7.5 15L12.5 10L7.5 5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>
    </div>
  );
}

export default StepTwo;